import { Component } from "@angular/core";

@Component({
    selector: 'redirect-external',
    template: ''
})
export class RedirectComponent{}